<div class="vi-toolbar {{ color }} flex flex-col" [class.shadow]="shadow">
  <mat-toolbar
    [color]="colorMap[color]"
    class="flex flex-row gap-[2px] justify-between items-center"
    [ngStyle]="{ 'max-height': height + 'px', 'min-height': height + 'px', flex: height + 'px' }"
  >
    <div>
      <div class="flex flex-row gap-[8px] justify-start items-center">
        <ng-content select="[left]"></ng-content>
      </div>
    </div>
    <div class="flex-1">
      <div class="flex flex-row gap-[8px] justify-center items-center">
        <ng-content select="[center]"></ng-content>
      </div>
    </div>
    <div class="flex-1">
      <div class="right flex flex-row gap-[8px] justify-end items-center">
        <ng-content select="[right]"></ng-content>
      </div>
    </div>
  </mat-toolbar>
</div>
